import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import dig from 'object-dig';
import Lottie from 'react-lottie';
import CurrentUser from '~/contexts/CurrentUser';

import LocalHospitalIcon from '@material-ui/icons/LocalHospital';

import LinearProgress from '~/components/LinearProgress';
import Typography from '@material-ui/core/Typography';

import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import Dialog from '~/components/Dialog';
import Button from '~/components/Button';

import uploadingLottie from '~/assets/lotties/uploading-to-cloud';

import Request from '~/providers/Request';
import { URL } from '~/config/uri';
import isPresent from '~/utils/isPresent';

import Form from './FormTriage';

function EditRecordTriage({
  isOpen,
  idClient,
  record,
  evolution,
  handleClose,
  onSuccess,
}) {
  const { user } = useContext(CurrentUser);

  const [evolutionText, setEvolutionText] = useState(null);
  const [files, setFiles] = useState([]);

  const [userPhysicalExamValue, setUserPhysicalExamValue] = useState('');
  const [userConductValue, setUserConductValue] = useState('');

  const [selectedOptions, setSelectedOptions] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingFiles, setLoadingFiles] = useState(false);
  const { t } = useTranslation();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: uploadingLottie,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  async function uploadFiles(evolutionId) {
    setLoadingFiles(true);

    const formData = new FormData();

    files.map((file) => {
      formData.append('file[]', file);
    });

    try {
      const authorizationToken = await Request.getAuth();

      const response = await fetch(
        `${URL}/admin/medical_record_evolutions/${evolutionId}/file`,
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: `Bearer ${authorizationToken}`,
          },
        }
      );
      setLoadingFiles(false);
      if (response.ok) {
        toast.success(t('action.save_success'));
        onSuccess();
      } else {
        toast.error(t('medical_record_evolutions.extras.save_fail'));
      }
    } catch (error) {
      console.error(error);
      setLoadingFiles(false);
    }
  }

  async function onSubmit() {
    console.log(selectedOptions);
    const typeEvolution = user.role === 'doctor' ? 1 : 0; 

    const data = {
      attributes: {
        notes: dig(evolutionText, 'notes'),
        user_id: idClient,
        medical_record_id: record.get('id'),
        date: new Date(),
        type_evolution: typeEvolution,
        physical_examination: '',
        conduct: '',
        cid_main_id: null,
        cid_secondary_id: null,
        service_exit_id: null,
        exams_ids: [],
        medicines_ids: []
      },
    };

    // "notes": "<p>Teste insert</p>",
    // "user_id": "33663",
    // "medical_record_id": "5275",
    // "date": "2024-08-14T21:45:42.216Z",
    // "type_evolution" : 1,
    // "physical_examination": "exame físico",
    // "conduct": "conduta",
    // "cid_main_id": 1,
    // "cid_secondary_id":1,
    // "service_exit_id": 1,
    // "exams_ids": [1,2,3, 4],
    // "medicines_ids": [5,6,7]

    setLoading(true);
    try {
      Request.put(
        `/admin/medical_record_evolutions/${evolution.id}`,
        { data },
        {},
        { controller: 'medical_record_evolutions' }
      ).then((response) => {
        setLoading(false);
        toast.success(t('action.save_success'));
        if (isPresent(files)) {
          uploadFiles(response.data.id);
        } else {
          onSuccess();
        }
      }).catch((error) => {
        console.error(error);
        setLoading(false);
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }

  const handleChangePhysicalExams = (e) => {
    const value = e.target.value;
    setUserPhysicalExamValue(value);
  };

  const handleChangeConduct = (e) => {
    const value = e.target.value;
    setUserConductValue(value);
  };

  const handleChangeEvolutionText = (data) => {
    setEvolutionText({ ...evolutionText, ...data });
  };

  const handleChangeMainObject = (data) => {
    setSelectedOptions(data);
  };

  useEffect(() => {
    setEvolutionText(null);
    setUserPhysicalExamValue('');
    setUserConductValue('');
    setFiles([]);
  }, [isOpen]);

  return (
    <Dialog
      icon={<LocalHospitalIcon />}
      isOpen={isOpen}
      handleClose={handleClose}
      title={'Nova Evolução - Enfermagem'}
      dialogActions={
        <>
          <Button
            disabled={loadingFiles || loading}
            color="grey"
            onClick={handleClose}
          >
            {t('action.cancel')}
          </Button>
          <Button
            disabled={loadingFiles || loading}
            color="green"
            onClick={onSubmit}
          >
            {t('action.save')}
          </Button>
        </>
      }
    >
      <>
        {!loadingFiles && (
          <Form
            onSubmit={onSubmit}
            setFiles={setFiles}
            loading={loading}
            evolution={evolutionText}
            userPhysicalExamValue={userPhysicalExamValue}
            userConductValue={userConductValue}
            handleChangeEvolutionText={handleChangeEvolutionText}
            handleChangePhysicalExams={handleChangePhysicalExams}
            handleChangeConduct={handleChangeConduct}
            handleChangeMainObject={handleChangeMainObject}
          />
        )}
        <LinearProgress loading={loadingFiles} />
        {loadingFiles && (
          <GridContainer direction="row" justify="center" alignItems="center">
            <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
              <Lottie options={defaultOptions} />
            </GridItem>
            <Typography
              variant="body2"
              color="secondary"
              style={{
                textAlign: 'center',
              }}
            >
              Aguarde enquanto salvamos os anexos.
            </Typography>
          </GridContainer>
        )}
        <LinearProgress loading={loadingFiles} />
      </>
    </Dialog>
  );
}

EditRecordTriage.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

EditRecordTriage.defaultProps = {
  isOpen: false,
};

export default EditRecordTriage;
